module.exports = __webpack_public_path__ + "static/CircularPro-BookItalic.f6763763.woff";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BookItalic.woff
// module id = 728
// module chunks = 168707334958949